import api from './core/api';

export interface UploadResult {
  url: string;
  storage: 'local' | 's3';
  fileName: string;
}

export async function uploadFormFile(file: File, folder: string): Promise<UploadResult> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('folder', folder);
  const res = await api.post('/admin/files/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data.data;
}
